import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { PUBLIC_SANDBOX_KEY } from '../App';
import { Session } from '../session';

const DEMO_NAME = import.meta.env.VITE_DEMO_NAME || 'Property Stack';

export default function Layout({
  session,
  onSignOut,
  children,
}: {
  session: Session;
  onSignOut: () => void;
  children: ReactNode;
}) {
  // True only for the shared public key from the marketing site's "See it in
  // action" link — never for a key emailed to a prospect or a customer.
  const isPublicSandbox = !!PUBLIC_SANDBOX_KEY && session.key === PUBLIC_SANDBOX_KEY;

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          {DEMO_NAME} <small>Search API demo</small>
        </div>

        <nav className="tabs">
          <NavLink to="/search" className={({ isActive }) => `tab${isActive ? ' active' : ''}`}>
            Search
          </NavLink>
          {/* Hidden rather than left to 403: the sandbox key has no ingest
              scope by design, so this tab has nothing to do for it. */}
          {!isPublicSandbox && (
            <NavLink to="/add" className={({ isActive }) => `tab${isActive ? ' active' : ''}`}>
              Add a listing
            </NavLink>
          )}
        </nav>

        <div className="who">
          <span>
            <strong>{session.tenant.slug}</strong> · {session.documents.indexed.toLocaleString()} indexed
          </span>
          <button className="ghost" onClick={onSignOut}>
            Sign out
          </button>
        </div>
      </header>

      {isPublicSandbox && (
        <div className="note info sandbox-banner">
          You're using the public sandbox — search only, sample data. Want to search your own
          catalogue? <a href="mailto:info@thepropertystack.com">Contact us</a> for your own key.
        </div>
      )}

      {children}
    </div>
  );
}
